
import { Component, Vue, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { delObjEmptyKey } from '@/utils'
import { Form as ElForm } from 'element-ui'
import { dateToSeconds, getOneDate, pickerOptions } from '@/utils/dateTime'
import {
  botPictureList,
  getAntOrcExport,
  getPictureOcrExport,
} from '@/api/report'
import { getEnterprise, setEnterprise } from '@/api/universal'

@Component({
  name: 'rebate',
  components: {},
})
export default class extends Vue {
  private queryForm: any = {
    name: '',
    nickname: '',
    ordernumber: '',
    start_time: null,
    end_time: null,
  }
  private exchangeForm: any = {
    nickname: '',
    ordernumber: '',
    start_time: null,
    end_time: null,
  }
  private suggestForm: any = {
    coin_id: '',
    upper_limit: '',
  }
  private date: any[] = getOneDate()
  private exchangeDate: any[] = getOneDate()
  private pickerOptions = pickerOptions

  private total = 0
  private list: any[] = []
  private listLoading: Boolean = false
  private activeName: string = '2'

  @Watch('date', { immediate: true })
  private onDateChang() {
    this.pickerChange()
  }

  // 创建时间监听
  private pickerChange() {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.queryForm.start_time = null
      this.queryForm.end_time = null
    }
  }

  @Watch('exchangeDate', { immediate: true })
  private onEnchangeChang() {
    this.exchangeChange()
  }

  // 创建时间监听
  private exchangeChange() {
    if (this.exchangeDate) {
      this.exchangeForm.start_time = dateToSeconds(this.exchangeDate[0])
      this.exchangeForm.end_time = dateToSeconds(this.exchangeDate[1])
    } else {
      this.exchangeForm.start_time = null
      this.exchangeForm.end_time = null
    }
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset() {
    this.queryForm = {
      name: '',
      nickname: '',
      ordernumber: '',
      start_time: null,
      end_time: null,
    }
    this.currentPage = 1
    this.date = getOneDate()
    this.pickerChange()
    this.hadleGetFilesListApi()
  }

  private exchangeReset() {
    this.exchangeForm = {
      nickname: '',
      ordernumber: '',
      start_time: null,
      end_time: null,
    }
    this.currentPage = 1
    this.exchangeDate = getOneDate()
    this.exchangeChange()
    this.hadleGetFilesListApi()
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      let data: any = {}
      if (this.activeName === '1') {
        data = {
          ...this.exchangeForm,
          data_type: this.activeName,
          page_size: this.pagesize,
          page: this.currentPage,
        }
      } else if (this.activeName === '2') {
        data = {
          ...this.queryForm,
          data_type: this.activeName,
          page_size: this.pagesize,
          page: this.currentPage,
        }
      }
      delObjEmptyKey(data)
      await botPictureList(data).then((res: any) => {
        // this.list = Object.values(res)
        this.list = res.results
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private suggestDisabled: boolean = false
  private async testOrderNotify() {
    try {
      this.suggestDisabled = true
      const data: any = {
        ssl_switch: {
          bot_photo_ocr: {
            ...this.suggestForm,
          },
        },
      }
      await setEnterprise(data).then((res: any) => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success',
        })
        this.suggestDisabled = false
        this.getEnterprise()
      })
    } catch (e) {
      this.suggestDisabled = false
    }
  }

  private async getEnterprise() {
    try {
      await getEnterprise().then((res: any) => {
        // this.suggestForm = res.ssl_switch.bot_photo_ocr
        if (res.ssl_switch.bot_photo_ocr) {
          this.suggestForm = res.ssl_switch.bot_photo_ocr
        } else {
          this.suggestForm = {
            coin_id: '',
            upper_limit: '',
          }
        }
      })
    } catch (e) {
      console.log()
    }
  }

  private handleClick(tab) {
    if (this.activeName === '1') {
      this.exchangeReset()
    } else if (this.activeName === '2') {
      this.reset()
    } else if (this.activeName === '3') {
      this.$nextTick(() => this.getEnterprise())
    }
  }

  // 导出
  private sendLoading: boolean = false
  private async exportData() {
    try {
      this.sendLoading = true
      let data: any = {
        start_time: this.queryForm.start_time,
        end_time: this.queryForm.end_time,
      }
      if (this.activeName === '2') {
        await getAntOrcExport(data).then(() => {
          this.$message({
            message: 'The form has been sent to your mailbox, please check it!',
            type: 'success',
          })
          this.sendLoading = false
        })
      } else {
        await getPictureOcrExport(data).then(() => {
          this.$message({
            message: 'The form has been sent to your mailbox, please check it!',
            type: 'success',
          })
          this.sendLoading = false
        })
      }
    } catch (e) {
      this.sendLoading = false
      // this.$message({
      //   message: 'Export failure!',
      //   type: 'error',
      // })
    }
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  private async init() {
    this.hadleGetFilesListApi()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.upparting`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }

  mounted() {
    this.init()
  }
}
